export default __webpack_public_path__ + "static/media/title_campaign.9d199f0b.png";